var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',_vm._b({directives:[{name:"mask",rawName:"v-mask",value:('##/##/####'),expression:"'##/##/####'"}],attrs:{"value":_vm.value,"dense":"","solo":""},model:{value:(_vm.dataDeNascimento),callback:function ($$v) {_vm.dataDeNascimento=$$v},expression:"dataDeNascimento"}},'v-text-field',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }